import React, { useState } from "react";
import styled, { css } from "styled-components";
import { color, flexCenter, intaglio, pageSetting } from "../styles/theme";
import axios from "axios";
import Submit from "../components/Submit";
import ImageUploader from "../components/ImageUploader";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/reducers";
import imageUploader from "../lib/imageUploader";
import { updateLoading } from "../store/reducers/loading";
import { BAROQUE_WORKS_ADDRESS, connects } from "../lib/metamask";
import { utils } from "ethers";

const RequestBugBounty = () => {
	const [data, setData] = useState<any>({ status: 0 });
	const { address } = useSelector((state: RootState) => state.metamask);
	const dispatch = useDispatch();

	const movieTest = () => {
		setData({
			projectName: "Dreamplus",
			github: "dreamplus@github.com",
			telegram: "dreamplus@telegram.com",
			twitter: "dreamplus@twiiter.com",
			discord: "dreamplus@discode.com",
			email: "dreamplus@gmail.com",
			bountyArea: "700",
			description: `In order to provide various opportunities and hopes to those who challenge their dreams and create synergy between them to become a virtuous cycle of sustainable innovation, We want to make a better world by being a catalyst for innovation that connects various dreams to each other. As an OPEN INNOVATION HUB and BUSINESS ENABLER that promotes collaboration, innovation, and growth among startup ecosystem players,
			\nIt contributes to the establishment and revitalization of a healthy startup ecosystem through connectivity among members.`,
			threatLevel: "High",
			walletAddress: "0x6a7692B7E5f26d832407DdcE8dF2F67E6CB01247",
			image:
				"http://res.cloudinary.com/dbyl7mbbg/image/upload/v1669461082/ddj4a0xurtgw1zwatcv4.png",
			sourceLink: "https://github.com/BaroqueWorks-hackathon/BaroqueWorks-frontend",
			sourceLink1: "https://github.com/with-key/practice_radix_ui.git",
			sourceLink2: "https://github.com/perifinance/peri.staking.git",
			webSiteUrl: "https://baroque-works.vercel.app/requestBugBounty",
			bounty: "40",
			reward: "60",
			status: 2,
			members: [{}, {}, {}, {}, {}],
			area: "SmartContract",
			deadline: 7,
		});
	};

	const onChangeHandler = (e: any, key: string) => {
		const obj: any = {};
		if (key === "image") {
			obj[key] = e;
		} else {
			obj[key] = e.target.value;
			console.log(data);
		}
		setData({ ...data, ...obj });
	};

	const onSubmitHandler = async () => {
		// if (!connects.web3Provider["BaroqueWorks"]) {

		// }
		dispatch(updateLoading(true));
		const uploadObj: any = { ...data };

		const totalBounty = utils
			.parseEther(uploadObj["bounty"])
			.add(utils.parseEther(uploadObj["reward"]));
		const approveTx = await connects.signers["DAI"].approve(BAROQUE_WORKS_ADDRESS, totalBounty);
		await connects.signers["DAI"].provider.once(approveTx.hash, async (transactionState: any) => {
			if (transactionState.status === 1) {
				try {
					const proposeTx = await connects.signers["BaroqueWorks"].propose(
						uploadObj["projectName"],
						utils.parseEther(uploadObj["bounty"]),
						utils.parseEther(uploadObj["reward"]),
						uploadObj["deadline"]
					);
					await connects.signers["BaroqueWorks"].provider.once(
						proposeTx.hash,
						async (transactionState: any) => {
							if (transactionState.status === 1) {
								try {
									const projectId = await connects.signers["BaroqueWorks"].getProjectLength();
									const imageUrl = await imageUploader(data.image);

									uploadObj["projectId"] = projectId.toString();
									uploadObj["walletAddress"] = address;
									uploadObj["image"] = imageUrl.url;

									await axios.post("http://localhost:4000/api/projects/project", uploadObj);
									dispatch(updateLoading(false));
								} catch (e) {
									console.log(e);
								}
							}
						}
					);
				} catch (e) {
					console.log(e);
				}
			}
		});
	};

	return (
		<RequestBugBountySection>
			<ProjectName>
				<ImageUploader onChangeHandler={onChangeHandler} value={data.image} />

				<div className="columnBox">
					<span onClick={() => movieTest()}>Project</span>
					<input
						type="text"
						placeholder="Project Name"
						autoFocus
						value={data.projectName}
						onChange={(e) => onChangeHandler(e, "projectName")}
					/>
				</div>
			</ProjectName>

			<div className="parentBox">
				<div style={{ width: "70%" }}>
					<h3 style={{ fontSize: "1.5rem" }}>Deposit Pool</h3>
				</div>

				<PoolInput>
					<div className="coin">
						<h4>Amounts</h4>
						<div className="coinItem">
							<img src="/dummy/dai.png" alt="dai" />
							<span>DAI</span>
						</div>
					</div>
					<div className="coin">
						<input
							type="text"
							value={data.bounty ? data.bounty : ""}
							placeholder="Base Bounty"
							onChange={(e) => onChangeHandler(e, "bounty")}
							className="coinParent"
							style={{ position: "relative" }}
						/>
					</div>
					{/* <h3>Bounty Reward</h3> */}

					<div className="coin">
						<input
							type="text"
							value={data.reward ? data.reward : ""}
							placeholder="Reward"
							onChange={(e) => onChangeHandler(e, "reward")}
							style={{ position: "relative" }}
						/>
					</div>
				</PoolInput>
			</div>

			{/* <DescriptBox>
				<h3>Base bounty</h3>
				<input
					type="text"
					value={data.bounty ? data.bounty : ""}
					onChange={(e) => onChangeHandler(e, "bounty")}
				/>
			</DescriptBox>
			<DescriptBox>
				<h3>Bounty Reward</h3>
				<input
					type="text"
					value={data.reward ? data.reward : ""}
					onChange={(e) => onChangeHandler(e, "reward")}
				/>
			</DescriptBox> */}
			<DescriptBox>
				<h3>Overview</h3>
				<textarea
					value={data.description ? data.description : ""}
					onChange={(e) => onChangeHandler(e, "description")}
					placeholder="overview"
				/>
			</DescriptBox>

			<DescriptBox status={data.status}>
				<h3>신규 or 기존 프로젝트?</h3>
				<div style={{ display: "flex" }}>
					<DetailBtn onClick={() => setData({ ...data, status: 1 })} className="new">
						신규
					</DetailBtn>
					<DetailBtn onClick={() => setData({ ...data, status: 2 })} className="origin">
						기존
					</DetailBtn>
				</div>
			</DescriptBox>

			<DescriptBox>
				<h3>공격에 대한 범위</h3>
				<textarea
					value={data.area ? data.area : ""}
					onChange={(e) => onChangeHandler(e, "area")}
					placeholder="공격에 대한 범위"
				/>
			</DescriptBox>

			<InputArea>
				<h2>Source Code Link</h2>
				<InputItem style={{ width: "100%" }}>
					<input
						value={data.sourceLink ? data.sourceLink : ""}
						placeholder="https://github.com/..."
						onChange={(e) => onChangeHandler(e, "sourceLink")}
					/>
				</InputItem>
				<InputItem style={{ width: "100%" }}>
					<input
						value={data.sourceLink1 ? data.sourceLink1 : ""}
						placeholder="https://github.com/..."
						onChange={(e) => onChangeHandler(e, "sourceLink1")}
					/>
				</InputItem>
				<InputItem style={{ width: "100%" }}>
					<input
						value={data.sourceLink2 ? data.sourceLink2 : ""}
						placeholder="https://github.com/..."
						onChange={(e) => onChangeHandler(e, "sourceLink2")}
					/>
				</InputItem>
				<div className="plus">
					<div className="plusCircle">
						<div>+</div>
					</div>
				</div>
			</InputArea>

			<InputArea>
				<h2>Social</h2>
				<InputItem>
					<img src="/icons/github.svg" alt="github" />
					<input
						type="text"
						value={data.github ? data.github : ""}
						placeholder="example@github.com"
						onChange={(e) => onChangeHandler(e, "github")}
					/>
				</InputItem>
				<InputItem>
					<img src="/icons/telegram.svg" alt="telegram" />
					<input
						type="text"
						value={data.telegram ? data.telegram : ""}
						placeholder="example@telegram.com"
						onChange={(e) => onChangeHandler(e, "telegram")}
					/>
				</InputItem>
				<InputItem>
					<img src="/icons/twitter.svg" alt="twitter" />
					<input
						type="text"
						value={data.twitter ? data.twitter : ""}
						placeholder="example@twitter.com"
						onChange={(e) => onChangeHandler(e, "twitter")}
					/>
				</InputItem>
				<InputItem>
					<img src="/icons/email.svg" alt="email" />
					<input
						type="text"
						value={data.email ? data.email : ""}
						placeholder="example@email.com"
						onChange={(e) => onChangeHandler(e, "email")}
					/>
				</InputItem>
				<InputItem>
					<img src="/icons/discord.svg" alt="discord" />
					<input
						value={data.discord ? data.discord : ""}
						placeholder="example@discord.com"
						onChange={(e) => onChangeHandler(e, "discord")}
					/>
				</InputItem>
				{/* <InputItem style={{ flexDirection: "column" }}>
					<span>Deadline</span>
					<input
						value={data.deadline ? data.deadline : ""}
						placeholder="Days"
						onChange={(e) => onChangeHandler(e, "deadline")}
					/>
				</InputItem> */}
			</InputArea>

			<Submit text="Submit" onClick={() => onSubmitHandler()} />
			<div style={{ marginTop: "3rem" }}></div>
		</RequestBugBountySection>
	);
};

const RequestBugBountySection = styled.section`
	${pageSetting}
`;

const ProjectName = styled.div`
	display: flex;
	width: 70%;
	margin-top: 5rem;
	margin-bottom: 6rem;
	padding-bottom: 2rem;

	.columnBox {
		display: flex;
		flex-direction: column;
		margin-left: 2rem;
	}

	h2 {
		font-size: 3rem;
	}

	input {
		font-size: 3rem;
		background: none;
		border: none;
		height: 6rem;
		outline: none;
	}

	border-bottom: 2px solid #262626;
`;

const InputArea = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	width: 70%;
	margin-bottom: 3rem;

	h2 {
		width: 70%;
		margin-bottom: 2rem;
	}

	.plus {
		display: flex;
		justify-content: center;
		width: 100%;

		.plusCircle {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			border-radius: 50%;
			width: 50px;
			height: 50px;
			border: 1px solid ${color.purple};
			padding: 0.5rem;
			box-sizing: border-box;
			background: ${color.purple};
			cursor: pointer;
		}

		div {
			font-size: 2rem;
			/* max-width: 3rem;
			max-height: 3rem; */
		}
	}
`;

const InputItem = styled.div`
	display: flex;
	width: 49%;
	max-height: 4.5rem;
	border: 1px solid ${color.green};
	border-radius: 13px;
	margin-bottom: 2rem;
	padding: 0.5rem 1rem;
	box-sizing: border-box;

	img {
		width: 2rem;
	}

	input {
		background: none;
		outline: none;
		border: none;
		width: 100%;
		color: ${color.white};
		font-size: 1rem;
		padding: 1rem;
		box-sizing: border-box;
	}
`;

interface IDetailBtn {
	status?: number;
}

const DescriptBox = styled.div<IDetailBtn>`
	width: 70%;
	margin-bottom: 5rem;

	h3 {
		font-size: 1.5rem;
		line-height: 3.9375rem;
	}

	textarea,
	input {
		${intaglio};

		display: flex;
		flex-direction: column;
		width: 100%;
		height: 30rem;
		padding: 1rem 2rem;
		box-sizing: border-box;
		font-size: 1rem;
		line-height: 2rem;
		color: ${color.white};
		/* border: none; */
		border: 1px solid ${color.white};
		/* background: #282828; */
		background: #141414;
		outline: none;
		white-space: wrap;

		&::placeholder {
			font-size: 1rem;
		}
	}

	${(props) =>
		props.status === 1 &&
		css`
			.new {
				background-color: #2ea977;

				transform: translateY(-7px);
			}

			.origin {
				background: #3d0962;
			}
		`}

	${(props) =>
		props.status === 2 &&
		css`
			.new {
				background: #3d0962;
			}

			.origin {
				background-color: #2ea977;

				transform: translateY(-7px);
			}
		`}
`;

const DetailBtn = styled.button`
	${flexCenter}
	align-items: center;
	width: 148.39px;
	height: 52.73px;
	background: #3d0962;
	border-radius: 13px;
	color: ${color.white};
	font-size: 14px;
	letter-spacing: 2.5px;

	transition: all 0.3s ease 0s;
	margin-right: 2rem;

	&:hover {
		background-color: #2ea977;
		box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
		transform: translateY(-7px);
	}
`;

const PoolInput = styled.div`
	display: flex;
	flex-direction: column;
	background-color: #141414;
	border: 0.5px solid #2c2c2c;
	padding: 0.9rem 0.6rem;
	box-sizing: border-box;
	border-radius: 13px;
	margin-bottom: 5rem;

	input {
		width: 30rem;
		height: 6rem;
		border-radius: 13px;
		font-size: 1.3rem;
		box-sizing: border-box;
		line-height: 2rem;
		border: none;
		margin: 2px;
		background: #262626;
		padding-left: 1rem;
	}

	.coin {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.coinItem {
			display: flex;
			align-items: center;
			/* background: gray; */
			z-index: 1;
			border-radius: 25px;
			padding: 0.3rem 1rem;
			box-sizing: border-box;

			img {
				width: 2rem;
				margin-right: 0.5rem;
			}

			span {
				font-size: 1rem;
			}
		}
	}
`;

export default RequestBugBounty;
